<template>
  <div>
    <b-tabs class="col-12 px-0 mx-0 mt-2" content-class="mt-3">
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"
              name="tasks"
            />Checklist Items
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <Maintenance tablename="g_checklistitems" />
        </b-card>
      </b-tab>
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"
              name="file-alt"
            />Checklist Texts
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <Maintenance tablename="g_checklisttexts" />
        </b-card>
      </b-tab>        
    </b-tabs>
  </div>
</template>
<script>
import Maintenance from './Maintenance';
export default {
  name: 'ChecklistSettings',
  mounted() {
  },
  components: {
    Maintenance,
  },
  data: function() {
    return {
    }
  },
  methods: {
  },
}
</script>
<style>
</style>
